var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "item",
      attrs: { id: `planItem${_vm.itemData.planId}` },
      on: {
        click: () => {
          _vm.goPlanLxDetail(_vm.itemData)
          _vm.setPlan()
        },
      },
    },
    [
      _vm.itemData.remainTime
        ? _c("div", { staticClass: "time_red nowrap" }, [
            _vm._v(" " + _vm._s(_vm.itemData.remainTime) + " "),
          ])
        : _vm._e(),
      _c("el-tag", { attrs: { size: "small" } }, [
        _vm._v(
          _vm._s(
            _vm.itemData.rule == 1
              ? _vm.$t("planHome.XH")
              : _vm.$t("planHome.DC")
          ) + _vm._s(_vm.$t("planHome.LX"))
        ),
      ]),
      _c(
        "el-tag",
        {
          staticStyle: { "margin-left": "6px" },
          attrs: { size: "small" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [_vm._v(_vm._s(_vm.itemData.planId))]
      ),
      _c(
        "h4",
        { staticClass: "nowrap", attrs: { title: _vm.itemData.planName } },
        [_vm._v(" " + _vm._s(_vm.itemData.planName) + " ")]
      ),
      _c("div", { staticClass: "time nowrap" }, [
        _vm._v(" " + _vm._s(_vm.itemData.beginTime)),
        _c("br"),
        _vm._v(" " + _vm._s(_vm.itemData.endTime) + " "),
      ]),
      _c(
        "div",
        {
          staticClass: "subject nowrap",
          attrs: { title: _vm.itemData.paperName },
        },
        [_vm._v(" " + _vm._s(_vm.itemData.paperName) + " ")]
      ),
      _vm.__userData.userType < 2
        ? _c(
            "div",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.itemData.status != "2",
                      expression: "itemData.status != '2'",
                    },
                  ],
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.endPlan.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("planHome.JSLX")))]
              ),
              _c(
                "span",
                {
                  staticStyle: { "margin-left": "6px" },
                  attrs: {
                    onclick: "(function(e){e.stopPropagation()}(event))",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: [["teacher", "student"], "pro"],
                          expression: "[['teacher', 'student'], 'pro']",
                        },
                      ],
                      attrs: {
                        type: "primary",
                        size: "mini",
                        disabled:
                          _vm.itemData.status == 0 || _vm.itemData.status == 1,
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.goNext.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("planHome.CKCJ")) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: [["teacher"], []],
                      expression: "[['teacher'], []]",
                    },
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.itemData.status == 2,
                      expression: "itemData.status == 2",
                    },
                  ],
                  staticStyle: { "margin-left": "6px" },
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.deletePlanBtn.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("planHome.SCJH")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("img", {
        staticClass: "plam_lx",
        attrs: { src: require("@/assets/image/plan_lx.png") },
      }),
      _vm.lang == "zh_CN"
        ? _c("img", {
            staticClass: "status",
            attrs: { src: _vm.imgs[_vm.itemData.status] },
          })
        : _c("img", {
            staticClass: "status",
            attrs: { src: _vm.imgs_copy[_vm.itemData.status] },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }